export default __webpack_public_path__ + "static/media/AMS_gray.159035ec.svg";